import type { DateTimeContextProps } from '@rtkwlf/fenrir-react';
import { formatDateString } from '@rtkwlf/fenrir-react';
import dayjs from 'dayjs';

import { TIMEZONE_LOCAL } from 'ae-constants/constants';

export type TimeZone = DateTimeContextProps['timezone'];
export const getDateTimeByTz = (
  value: string | number,
  timezone: TimeZone,
): string => {
  const f = 'MMM D, YYYY h:mm A';
  const date = new Date(value);

  if (timezone === TIMEZONE_LOCAL) {
    return dayjs(date).format(f);
  }

  return formatDateString(dayjs(date), timezone, 'logDateTime');
};
